import React, { useContext, useState, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Fade from 'react-reveal/Fade';

import { ThemeContext } from '../../contexts/ThemeContext';

import './Experience.css';

function ExperienceCard({ id, company, jobtitle, startYear, endYear, image, details = [] }) {
    const { theme } = useContext(ThemeContext);
    const [expanded, setExpanded] = useState(false);

    const toggle = useCallback(() => setExpanded((e) => !e), []);
    const onKeyDown = useCallback((e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggle();
        }
    }, [toggle]);

    const useStyles = makeStyles(() => ({
        experienceCard: {
            backgroundColor: theme.primary30,
            cursor: 'pointer',
            transition: 'background-color 200ms ease',
            "&:hover": {
                backgroundColor: theme.primary50,
            },
            outline: 'none',
        },
        caret: {
            display: 'inline-block',
            transition: 'transform 200ms ease',
            transform: expanded ? 'rotate(90deg)' : 'rotate(0deg)'
        }
    }));

    const classes = useStyles();

    return (
        <Fade bottom>
            <div
                key={id}
                className={`experience-card ${classes.experienceCard}`}
                role="button"
                tabIndex={0}
                onClick={toggle}
                onKeyDown={onKeyDown}
                aria-expanded={expanded}
                aria-controls={`exp-details-${id}`}
            >
                <div className="expcard-img" style={{ backgroundColor: theme.tertiary }}>
                    <img src={image} alt={`Experience ${id}`} />
                </div>

                <div className="experience-details">
                    <div className="experience-header">
                        <h6 style={{ color: theme.primary }}>{startYear} - {endYear}</h6>
                        <span className={`exp-caret ${classes.caret}`} aria-hidden>▶</span>
                    </div>
                    <h4 style={{ color: theme.tertiary }}>{jobtitle}</h4>
                    <h5 style={{ color: theme.tertiary80 }}>{company}</h5>
                </div>

                <div
                    id={`exp-details-${id}`}
                    className={`exp-details ${expanded ? 'expanded' : ''}`}
                >
                    {details && details.length > 0 ? (
                        <ul>
                            {details.map((d, idx) => (
                                <li key={idx} style={{ color: theme.tertiary }}>
                                    {d}
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p style={{ color: theme.tertiary60, margin: 0 }}>
                            More details coming soon.
                        </p>
                    )}
                </div>
            </div>
        </Fade>
    );
}

export default ExperienceCard;
